import { useBoundStore } from '@Store/useBoundStore';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient.ts';
import { useEffect } from 'react';
import App from './App';
import './in18/in18.ts';



export const InitApp = () => {
  useEffect(() => {
    useBoundStore.getState().setIsHydrated(true);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  );
};
